export const imageCacheService = {
  addObserver: observer => imageCacheService.observers.push(observer),
  cache: {},
  imageCache: path => callback => {
    if (imageCacheService.cache[path]) {
      const cached = imageCacheService.cache[path]
      if (cached.loaded) {
        return callback(cached.img)
      } else {
        cached.callbacks.push(callback)

        return
      }
    }

    const img = new Image()
    img.src = path
    img.onload = () => {
      img.onload = null
      imageCacheService.cache[path].loaded = true
      imageCacheService.cache[path].callbacks.forEach(c => c(img))
      imageCacheService.notifyObservers(path)
    }

    imageCacheService.cache[path] = {
      callbacks: [callback],
      img,
      loaded: false,
    }
  },
  notifyObservers: value => imageCacheService.observers.forEach(o => o(value)),

  observers: [],

  roomCache: {},

  roomImageCache: roomIcon => callback => {
    if (!imageCacheService.roomCache[roomIcon]) {
      import(`../../assets/room_types/dark/${roomIcon}.png`).then(img => {
        imageCacheService.roomCache[roomIcon] = img.default
        imageCacheService.imageCache(img.default)(callback)
      })
    } else {
      imageCacheService.imageCache(imageCacheService.roomCache[roomIcon])(
        callback,
      )
    }
  },
}
